module.exports = __webpack_public_path__ + "assets/payment-black.b0100953.svg";